PJQ.views.directcosts.ProjectDirectCosts = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DIRECTCOSTS, 'direct-costs-list'),
        directCostId: null
    },
    events: {
        'click .btn-pull-erp': 'pullERP',
        'click .btn-settings': 'editSettings',
        'click .new-direct-cost': 'newDirectCost',
        'click .btn-view-direct-cost': 'viewDirectCostClicked',
        'click .btn-delete-direct-cost': 'deleteDirectCostClicked',
        'click .btn-export': 'exportList'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.directcosts.DirectCosts(null, {
                projectId: this.options.project.get('projectId'),
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.settings = await PJQ.app.session.fetchDirectCostSettings();
        this.userSettings = await PJQ.app.session.fetchDirectCostUserSettings();
        this.customFields = await this.options.project.fetchDirectCostCustomFields();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canAdd = PJQ.app.session.project.hasPermission('directCosts.canAdd');
        this.options.canEdit = PJQ.app.session.project.hasPermission('directCosts.canEdit');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('directCosts.isAdmin');
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            canAdd: this.options.canAdd,
            isAdmin: this.options.isAdmin,
            erpIntegration: this.erpIntegration
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        if (this.options.directCostId > 0) {
            let initDirectCost = this.collection.get(this.options.directCostId);
            if (initDirectCost != null) {
                this.viewDirectCost(initDirectCost);
                this.options.directCostId = null;
            }
        }
    },
    renderStats: function () {
        let totals = this.collection.getTotalAmountsByStatus();
        this.$('.total-draft').text(PJQ.helpers.formatHelpers.formatCurrency(totals[PJQ.constants.directcosts.directCostStatus.DRAFT]));
        this.$('.total-pending').text(PJQ.helpers.formatHelpers.formatCurrency(totals[PJQ.constants.directcosts.directCostStatus.PENDING]));
        this.$('.total-approved').text(PJQ.helpers.formatHelpers.formatCurrency(totals[PJQ.constants.directcosts.directCostStatus.APPROVED]));
        this.$('.total-revise').text(PJQ.helpers.formatHelpers.formatCurrency(totals[PJQ.constants.directcosts.directCostStatus.REVISE]));
    },
    renderERPButton: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_DIRECT_COSTS) === false || !this.options.project || !this.options.project.isERPSynced()) {
            $erp.remove();
            return;
        }

        let pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_DIRECT_COSTS);
        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: false,
            pullSupported: pullSupported,
            canPull: true
        });
    },
    pullERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_DIRECT_COSTS)) {
            this.erpIntegration.pullDirectCosts(this.options.project, (res, err) => {
                if (res == null) {
                    return;
                }

                PJQ.notifications.notify.successNotify({
                    message: 'Direct cost transactions pulled from ERP'
                });
                this.directCosts = res;

                this.collection.fetch({
                    success: () => {
                        this.render();
                    }
                });
            });
        }
    },
    getFilterValues: function () {
        let directCostTypes = this.filterSelectPicker.getValue()[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER];
        directCostTypes = _.map(directCostTypes, function (type) {
            return type * -1;
        });
        return {
            projectId: this.options.project.get('projectId'),
            search: this.$('.input-search').val(),
            typeFilter: directCostTypes.join(','),
            statusFilter: this.filterSelectPicker.getValue()[PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER].join(',')
        };
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
        this.renderStats();
    },
    getDataTableInstance: function () {
        return new PJQ.views.directcosts.DirectCostDataTable({
            el: this.$('.direct-cost-data'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    canAdd: this.options.canAdd,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            directCostView: this,
            customFields: this.customFields,
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.directcosts.view.DIRECT_COSTS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                this.userSettings.save();
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.viewDirectCost(row.data());
            }, this),
            afterDataTableRender: _.bind(function () {
                this.renderERPButton();
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewDirectCost(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    editSettings: function () {
        new PJQ.views.directcosts.DirectCostSettingsModal({
            directCostView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    newDirectCost: function (e) {
        this.viewDirectCost();
    },
    viewDirectCostClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewDirectCost(row.data());
    },
    viewDirectCost: function (directCost) {
        let isNew = directCost == null;
        new PJQ.views.directcosts.DirectCostEditModal({
            model: directCost,
            settings: this.settings,
            customFields: this.customFields,
            onSave: _.bind(function (directCost) {
                if (isNew) {
                    this.collection.add(directCost);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (directCost) {
                this.collection.remove(directCost);
                this.renderView();
            }, this)
        });
    },
    deleteDirectCostClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteDirectCost(row);
    },
    deleteDirectCost: function (row) {
        if (row != null) {
            let directCost = row.data();
            if (directCost != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Direct Cost",
                    body: "Are you sure you want to delete this Direct Cost?",
                    onDelete: _.bind(function () {
                        directCost.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(directCost);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    exportList: function () {
        let filter = this.dataTable.getFilterValues(),
            parameters = [
                {
                    parameter: 'search',
                    value: filter.search
                },
                {
                    parameter: 'typeFilter',
                    value: filter.typeFilter
                },
                {
                    parameter: 'statusFilter',
                    value: filter.statusFilter
                },
                {
                    parameter: 'timeZoneOffset',
                    value: new Date().getTimezoneOffset()
                }
            ];

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'export'
            }
        ], parameters), {isAPIv2: true});
    },
    renderTotals: function (draft, total) {
        this.$('.total-draft').text(PJQ.helpers.formatHelpers.formatCurrency(draft));
        this.$('.total-direct-costs').text(PJQ.helpers.formatHelpers.formatCurrency(total));
    }
});

PJQ.views.directcosts.ModalViewDirectCosts = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DIRECTCOSTS, 'modal-view-direct-costs'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.directcosts.ProjectDirectCosts({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                project: this.options.project
            })
        }
    },
});